import * as Types from '../graphql-api';

import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';
export type CheckAuthQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CheckAuthQuery = { __typename?: 'Query', profile: { __typename?: 'Profile', user?: { __typename?: 'User', id?: number | null, name?: string | null, email?: string | null, avatar?: string | null, permission?: Array<{ __typename?: 'Permission', id?: string | null, name?: string | null }> | null, customer?: { __typename?: 'Customer', name?: string | null, account?: { __typename?: 'Account', holdAmount?: any | null, postedBalance?: any | null, currency?: { __typename?: 'Currency', id?: string | null, sign?: string | null } | null } | null, profile?: { __typename?: 'AccountProfile', aiEnable?: boolean | null } | null } | null } | null } };

export type LoginQueryVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
  password: Types.Scalars['String']['input'];
}>;


export type LoginQuery = { __typename?: 'Query', login?: string | null };

export type TempSessionLoginQueryVariables = Types.Exact<{
  session: Types.Scalars['String']['input'];
}>;


export type TempSessionLoginQuery = { __typename?: 'Query', tempSessionLogin?: string | null };

export type CreateTempSessionMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type CreateTempSessionMutation = { __typename?: 'Mutation', createTempSession?: string | null };


export const CheckAuthDocument = gql`
    query checkAuth {
  profile {
    user {
      id
      name
      email
      avatar
      permission {
        id
        name
      }
      customer {
        name
        account {
          holdAmount
          postedBalance
          currency {
            id
            sign
          }
        }
        profile {
          aiEnable
        }
      }
    }
  }
}
    `;
export const LoginDocument = gql`
    query login($email: String!, $password: String!) {
  login(email: $email, password: $password)
}
    `;
export const TempSessionLoginDocument = gql`
    query tempSessionLogin($session: String!) {
  tempSessionLogin(session: $session)
}
    `;
export const CreateTempSessionDocument = gql`
    mutation createTempSession {
  createTempSession
}
    `;
export type Requester<C = {}> = <R, V>(doc: DocumentNode, vars?: V, options?: C) => Promise<R> | AsyncIterable<R>
export function getSdk<C>(requester: Requester<C>) {
  return {
    checkAuth(variables?: CheckAuthQueryVariables, options?: C): Promise<CheckAuthQuery> {
      return requester<CheckAuthQuery, CheckAuthQueryVariables>(CheckAuthDocument, variables, options) as Promise<CheckAuthQuery>;
    },
    login(variables: LoginQueryVariables, options?: C): Promise<LoginQuery> {
      return requester<LoginQuery, LoginQueryVariables>(LoginDocument, variables, options) as Promise<LoginQuery>;
    },
    tempSessionLogin(variables: TempSessionLoginQueryVariables, options?: C): Promise<TempSessionLoginQuery> {
      return requester<TempSessionLoginQuery, TempSessionLoginQueryVariables>(TempSessionLoginDocument, variables, options) as Promise<TempSessionLoginQuery>;
    },
    createTempSession(variables?: CreateTempSessionMutationVariables, options?: C): Promise<CreateTempSessionMutation> {
      return requester<CreateTempSessionMutation, CreateTempSessionMutationVariables>(CreateTempSessionDocument, variables, options) as Promise<CreateTempSessionMutation>;
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;